import { ProductType } from '@/generated/enums'
import { StatsTab } from '@/utils/constants'
import { formatSnakeStringWithCapitalization } from '@/utils/string_utils'
import {
  DOPPEL_BLUE_200,
  DOPPEL_CYAN_300,
  DOPPEL_GREEN_300,
  DOPPEL_PINK_300,
  DOPPEL_YELLOW_200,
} from '@/utils/style'
import { useEffect } from 'react'
import flags from 'emoji-flags'

export const WIDGET_UNIT_HEIGHT_PX = 114

export const STATS_CYAN = DOPPEL_CYAN_300
export const STATS_BLUE = DOPPEL_BLUE_200
export const STATS_GREEN = DOPPEL_GREEN_300
export const STATS_VIOLET = DOPPEL_PINK_300
export const STATS_YELLOW = DOPPEL_YELLOW_200
export const STATS_PURPLE = '#6C2DF2'

// ensures only supported product tabs are included in the summary
export const tabToProductType = {
  [StatsTab.BRAND_ABUSE]: ProductType.DOMAIN,
  [StatsTab.SOCIAL_MEDIA]: ProductType.SOCIAL_MEDIA,
  [StatsTab.MOBILE_APPS]: ProductType.MOBILE_APP,
  // [StatsTab.DARK_WEB]: ProductType.DARKWEB, // re-add once support is fixed
  [StatsTab.ECOMMERCE]: ProductType.ECOMMERCE,
  [StatsTab.EMPLOYEE_ABUSE_BOX]: ProductType.SUSPICIOUS_EMAILS,
  [StatsTab.PAID_ADS]: ProductType.PAID_AD,
  [StatsTab.CRYPTO]: ProductType.CRYPTO,
  [StatsTab.TELCO]: ProductType.TELCO,
}

// hack to extract loading state from next/dynamic, to unify with data-loading interface
type LazyLoadStateProps = {
  setLoading: (loading: boolean) => void
}
export const LazyLoadState = ({ setLoading }: LazyLoadStateProps) => {
  useEffect(() => {
    setLoading(true)

    return () => setLoading(false)
  })
  return null
}

export const formatDateToUTC = (date, includeTime = true) => {
  const year = date.getUTCFullYear()
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
  const day = date.getUTCDate().toString().padStart(2, '0')
  const hours = date.getUTCHours().toString().padStart(2, '0')
  const minutes = date.getUTCMinutes().toString().padStart(2, '0')

  if (includeTime) {
    return `${year}-${month}-${day} ${hours}:${minutes}`
  } else {
    return `${year}-${month}-${day}`
  }
}

export const getFlagEmoji = (countryCode) => {
  return flags[countryCode]?.emoji
}

export const processCountryCodeData = (data, includeFlag = true) => {
  return data.map((item) => ({
    ...item,
    label: (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {includeFlag && (
          <span style={{ fontSize: '16px', marginRight: '8px' }}>
            {getFlagEmoji(item.label.toUpperCase())}
          </span>
        )}

        {item.label}
      </span>
    ),
  }))
}

export const formatLabelToTitleCase = (data) => {
  return data.map((item) => ({
    ...item,
    label: formatSnakeStringWithCapitalization(item.label),
  }))
}
